export const PREMIUM_MODAL_KEY                      = 'modal_premium'
export const PREMIUM_MODAL_SILENCE_DURATION         = 86400 // 24 hours

export const VERIFIED_MODAL_KEY                     = 'modal_verified'
export const VERIFIED_MODAL_SILENCE_DURATION        = 86400

export const PROFILE_PHOTO_MODAL_KEY                = 'modal_profile_photo'
export const PROFILE_PHOTO_MODAL_SILENCE_DURATION   = 86400

export const NET_WORTH_MODAL_KEY                = 'modal_net_worth'
export const NET_WORTH_MODAL_SILENCE_DURATION   = 86400

export const OFFERS_MODAL_KEY                = 'modal_offers'
export const OFFERS_MODAL_SILENCE_DURATION   = 86400

export const INTERESTED_IN_MODAL_KEY                = 'modal_offers'
export const INTERESTED_IN_MODAL_SILENCE_DURATION   = 86400